import apiFetch from '@wordpress/api-fetch';
import { decodeEntities } from '@wordpress/html-entities';
import { __, _x } from '@wordpress/i18n';

document.addEventListener( 'DOMContentLoaded', () => {
	const blockContainer = document.getElementById(
		'block-wrapper-artist-spectacles'
	); // Adjust to your block's class

	const postId = blockContainer.dataset.artistId;
	// Set up intersection observer for all lazy posts containers
	const observer = new IntersectionObserver(
		( entries ) => {
			entries.forEach( ( entry ) => {
				if ( entry.isIntersecting ) {
					// Check if posts have already been loaded
					if ( blockContainer.dataset.cntLoaded === 'false' ) {
						loadPosts( postId, blockContainer );
						blockContainer.dataset.cntLoaded = 'true';

						// Stop observing after first load
						observer.unobserve( blockContainer );
					}
				}
			} );
		},
		{
			threshold: 0.1, // Trigger when 10% of the element is visible
		}
	);

	if ( ! blockContainer ) return;

	// Start observing lazy posts containers
	observer.observe( blockContainer );
} );

// Reading the Current Page
// Extracts the current page from the URL query parameters
const getPageFromURL = () => {
	const params = new URLSearchParams( window.location.search );
	return parseInt( params.get( 'spectacles-page' ), 10 ) || 1;
};

// Updating the URL
// Updates the query parameter when the page changes without reloading
const updatePageInURL = ( page ) => {
	const params = new URLSearchParams( window.location.search );
	params.set( 'spectacles-page', page );
	const newUrl = `${ window.location.pathname }?${ params.toString() }`;
	window.history.pushState( { page }, '', newUrl );
};

async function loadPosts( postId, blockContainer ) {
	const cardsContainer = document.createElement( 'div' );
	const paginationContainer = document.createElement( 'div' );
	const noPostsMessage = document.createElement( 'p' );

	let currentPage = 1;
	let totalPages = 1;
	let isLoading = false;

	cardsContainer.className = 'cnt-cards-container';
	paginationContainer.className = 'pagination-buttons';
	paginationContainer.id = 'artist-spectacles-pagination';
	noPostsMessage.textContent = __( "Cet artiste n'a pas de spectacles pour le moment.", 'cnt' );
	noPostsMessage.style.display = 'none';

	blockContainer.appendChild( cardsContainer );
	blockContainer.appendChild( paginationContainer );
	blockContainer.appendChild( noPostsMessage );

	paginationContainer.addEventListener( 'click', ( e ) =>
		handlePageChange( e )
	);

	const handlePageChange = ( e ) => {
		const page = e.target.dataset.targetPage;
		if ( page > 0 && page <= totalPages ) {
			currentPage = page;
			updatePageInURL( page );
			fetchPosts( page );
		}
	};

	const setPrevBtn = ( currentPage ) => {
		const prev = currentPage != 1 ? currentPage - 1 : false;
		//prev. button
		if ( prev ) {
			const prevBtn = document.createElement( 'button' );
			prevBtn.setAttribute( 'type', 'button' );
			prevBtn.setAttribute( 'class', ` pagination__button` );
			prevBtn.setAttribute( 'data-target-page', prev );
			prevBtn.setAttribute(
				'aria-label',
				`${ __( 'précédent', 'cnt' ) }`
			);
			prevBtn.innerHTML = `<svg class="pagination__icon arrow-btn" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.214 23.111">
				  <path d="m3.984 11.551 8.745-8.739a1.645 1.645 0 0 0 0-2.333 1.665 1.665 0 0 0-2.339 0l-9.908 9.9a1.649 1.649 0 0 0-.048 2.278l9.95 9.97a1.652 1.652 0 0 0 2.338-2.329Z" /></svg>`;
			paginationContainer.appendChild( prevBtn );
		}

		return;
	};

	const setNextBtn = ( currentPage, totalPages ) => {
		const next = currentPage != totalPages ? currentPage + 1 : false;

		//prev. button
		if ( next ) {
			const nextBtn = document.createElement( 'button' );
			nextBtn.setAttribute( 'type', 'button' );
			nextBtn.setAttribute( 'class', ` pagination__button` );
			nextBtn.setAttribute( 'data-target-page', next );
			nextBtn.setAttribute(
				'aria-label',
				`${ __( 'suivante', 'cnt' ) }`
			);

			nextBtn.innerHTML = `<svg class="pagination__icon arrow-btn" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.214 23.111">
			<path d="m9.231 11.506-8.745 8.739a1.645 1.645 0 000 2.333 1.665 1.665 0 002.339 0l9.908-9.9a1.649 1.649 0 00.048-2.278l-9.95-9.97a1.652 1.652 0 00-2.338 2.329z"/>
			</svg>`;
			paginationContainer.appendChild( nextBtn );
		}

		return;
	};

	const setPagination = ( totalPages = 1, currentPage = 1 ) => {
		// check if the total pages is more than 1
		if ( ! totalPages || totalPages == 1 ) {
			return;
		}

		let counter = 1;
		let target = 1;

		//reset pagination
		paginationContainer.innerHTML = '';

		setPrevBtn( currentPage );
		//prints a maximum of 5 elements. The first element has a target of 1 and the fifth element target is the total of pages
		while ( totalPages >= counter && counter <= 5 ) {
			const btnElement = document.createElement( 'button' );
			btnElement.setAttribute( 'type', 'button' );
			btnElement.setAttribute(
				'class',
				` pagination__button ${
					target == currentPage ? 'current' : ''
				}`
			);
			btnElement.setAttribute(
				'aria-label',
				`${ __( 'allez à la page numéro', 'cnt' ) } ${ target }`
			);

			if ( totalPages > 5 ) {
				//increment counter
				switch ( counter ) {
					case 1:
						paginationContainer.appendChild( btnElement );

						if ( currentPage > 3 ) {
							const separatorElement =
								document.createElement( 'span' );
							separatorElement.textContent = '...';
							paginationContainer.appendChild( separatorElement );
						}
						break;
					case 2:
						paginationContainer.appendChild( btnElement );

						if ( currentPage === totalPages ) {
							target = currentPage - 3;
						} else if ( currentPage + 1 == totalPages ) {
							target = currentPage - 2;
						} else if ( currentPage > 3 ) {
							target = currentPage - 1;
						}
						break;
					case 5:
						if ( currentPage + 2 < totalPages ) {
							const separatorElement =
								document.createElement( 'span' );
							separatorElement.textContent = '...';
							paginationContainer.appendChild( separatorElement );
						}
						paginationContainer.appendChild( btnElement );
						target = totalPages;
						break;
					default:
						paginationContainer.appendChild( btnElement );
						break;
				}
			} else {
				paginationContainer.appendChild( btnElement );
			}

			btnElement.setAttribute( 'data-target-page', target );
			btnElement.textContent = target;

			counter++;
			target++;
		}

		setNextBtn( currentPage, totalPages );
	};

	function setPlaceholderVisibility(isVisible = true){
	
		if(	cardsContainer ){
			if(isVisible) {
				cardsContainer.innerHTML = '';
				const requiredCards = 8;
				let count = 0;
				while( count < requiredCards){
					const wrapper = document.createElement("div");
					const title = document.createElement("div");
					const date = document.createElement("div");
					const excerpt = document.createElement("div");
					const category = document.createElement("div");
	
					wrapper.classList.add("card__skeleton");
					title.classList.add("card__skeleton-title");
					date.classList.add("card__skeleton-date");
					excerpt.classList.add("card__skeleton-excerpt");
					category.classList.add("card__skeleton-category");
	
					wrapper.appendChild(title);
					wrapper.appendChild(date);
					wrapper.appendChild(excerpt);
					wrapper.appendChild(category);
	
					cardsContainer.appendChild(wrapper);
					count++;
				}
			} else {
				const skeletons = cardsContainer.querySelectorAll('.card__skeleton');
	
				skeletons.forEach(skeleton => {
					skeleton.style.opacity = '0';
					setTimeout(() => skeleton.remove(), 200);
				});
			}
		}
	}
	

	const fetchPosts = async ( page = 1 ) => {
		if ( isLoading ) return;
		isLoading = true;
		noPostsMessage.style.display = 'none';

		try {
			setPlaceholderVisibility(true);

			const response = await apiFetch( {
				path: `/cnt-plugin/v1/artist-spectacles?id=${ postId }&spectacles-page=${ page }`,
			} );

			if ( !response || !response.posts || response.posts.length === 0 ) {
				noPostsMessage.style.display = 'block';
				cardsContainer.innerHTML = '';
				totalPages = 1; // Reset total pages if no posts found
				setPlaceholderVisibility(false);
			} 
			else {
				setPlaceholderVisibility(false);
				renderPosts( response );
			}

			// Fetch total pages from headers
			const total =
				response && response.posts && response.total_pages
					? response.total_pages
					: 1;
			totalPages = parseInt( total, 10 ) || 1;
			currentPage = parseInt( page, 10 );

			setPagination( totalPages, currentPage );
		} catch ( error ) {
			console.error( 'Error fetching houses:', error );
			setPlaceholderVisibility(false);
		} finally {
			isLoading = false;
		}
	};

	const renderPostTaxPublic = ( post, cardContent ) => {
		if ( post.taxonomies.cnt_public_tax ) {
			const publicList = document.createElement( 'p' );
			publicList.className = 'cnt-card__public-terms';

			post.taxonomies.cnt_public_tax.map( ( item ) => {
				const publicTerm = document.createElement( 'span' );

				publicTerm.textContent = item;
				publicTerm.className = 'cnt-card__public-term';
				publicList.appendChild( publicTerm );
			} );

			cardContent.appendChild( publicList );
		}
	};

	const renderPostTaxRegion = ( post, cardContent ) => {
		if ( post.taxonomies.cnt_region_tax ) {
			const regionList = document.createElement( 'p' );
			regionList.className = 'cnt-card__region-terms';
			regionList.textContent = `Province : ${ post.taxonomies.cnt_region_tax?.join(
				' · '
			) }`;

			cardContent.appendChild( regionList );
		}
	};

	const renderPostDuration = ( post, cardContent ) => {
		if ( post.duration && post.duration.length > 0 ) {
			const durationList = document.createElement( 'p' );
			const isMultiple = post.duration.length > 1;
			const durationSingle = isMultiple ? false : parseInt(post.duration);
			durationList.className = 'cnt-card__duration-terms';

			if( isMultiple ){
				durationList.textContent = `Durée variable`
			} else if( !isNaN(durationSingle)){
				durationList.textContent = `Durée : ${durationSingle} minute(s)`
			}

			cardContent.appendChild( durationList );
		}
	};

	const renderPost = ( post ) => {
		const thumbnailId = post.featured_image || '';
		const shortDescr = decodeEntities( post.excerpt ) || '';
		const postTitle = post.title.length > 1 ? decodeEntities( post.title ) : "Sans titre";

		const card = document.createElement( 'div' );
		card.className = 'cnt-card';

		const cardImage = document.createElement( 'div' );
		const cardImageInner = document.createElement( 'div' );

		cardImage.className = 'cnt-card__visual';
		cardImageInner.className = 'cnt-card__visual--inner';

		const cardContent = document.createElement( 'div' );
		cardContent.className = 'cnt-card__content';

		cardImage.appendChild( cardImageInner );

		if ( thumbnailId ) {
			const img = document.createElement( 'img' );
			img.src = thumbnailId;
			img.alt = decodeEntities(post.alt_text);
			img.setAttribute("aria-hidden", "true");
			cardImageInner.appendChild( img );
		} else {
			cardImageInner.classList.add(`has-spectacle-placeholder`);
		}

		const title = document.createElement( 'h3' );
		title.className = 'cnt-card__title';
		const titleLink = document.createElement( 'a' );
		titleLink.href = post.link;
		titleLink.className = 'cnt-card__link';
		titleLink.textContent = postTitle;

		title.appendChild( titleLink );
		cardContent.appendChild( title );

		if ( shortDescr ) {
			const description = document.createElement( 'p' );
			description.textContent = shortDescr;
			cardContent.appendChild( description );
		}

		renderPostTaxPublic( post, cardContent );
		renderPostTaxRegion( post, cardContent );
		renderPostDuration( post, cardContent );

		card.appendChild( cardImage );
		card.appendChild( cardContent );
		cardsContainer.appendChild( card );
	};

	const renderPosts = ( response ) => {
		cardsContainer.innerHTML = '';

		response?.posts.forEach( ( post ) => {
			renderPost( post );
		} );
	};

	// Initialization
	// Load the initial page based on URL
	currentPage = getPageFromURL();
	// Fetch the initial page
	fetchPosts( currentPage );
}
